<template>
  <div>
    <!--门店信息-->
    <div>
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(banner_img,index) in store.environment_img" :key="index">
          <img :src="banner_img" alt />
        </van-swipe-item>
      </van-swipe>
      <!-- <img src="../../../static/img/store_banner.png" alt=""> -->
      <div class="storeCenter__info">
        <div class="storeList flex_center" >
          <div class="storeList__img"><img :src="store.logo" alt=""></div>
          <div class="storeList__content">
            <div class="col_666 fs_12 storeInfo__details">
              <p>地址：{{store.address}}</p>
              <p>电话：{{store.tel}}</p>
              <p v-if="store.sale_starttime!=0">营业时间：{{store.sale_starttime}}-{{store.sale_endtime}}</p>
              <p v-else>营业时间：全天营业</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--我的订单-->
    <div class='mb_10'>
      <van-cell  @click="order_jump(0)" title="订单" value="全部订单" title-class="fs_15" value-class="fs_12" is-link :border="false" />
      <div class="storeOrder__menu bt_1">
        <van-tabbar :fixed="false" :border="false" active-color="#666" inactive-color="#666">
          <van-tabbar-item :info="totaldaijiedan==0?'':totaldaijiedan" @click="order_jump(1)"><span>待接单</span><img slot="icon"  :src="icon.order_icon1"></van-tabbar-item>
          <van-tabbar-item :info="totaldaifuwu==0?'':totaldaifuwu" @click="order_jump(2)"><span>待服务</span><img slot="icon" :src="icon.order_icon2"></van-tabbar-item>
          <van-tabbar-item :info="totalhexiao==0?'':totalhexiao" @click="order_jump(3)"><span>已核销</span><img slot="icon"  :src="icon.order_icon3"></van-tabbar-item>
          <van-tabbar-item :info="totalyichuli==0?'':totalyichuli" @click="order_jump(-1)"><span>已取消</span><img slot="icon"  :src="icon.order_icon4"></van-tabbar-item>
          <!-- <van-tabbar-item info=""><span>已取消</span><img slot="icon" slot-scope="props" :src="icon.order_icon4"></van-tabbar-item> -->
        </van-tabbar>
      </div>
    </div>
    <!--列表-->
    <div class="mb_10">
     <van-cell :to="{path:'/store_income',query:{'store_id':store.id}}" title="分成收入" is-link>
        <van-icon slot="icon" class=" iconfont icon-qian col_EA6953"/>
      </van-cell>
      <van-cell :to="{path:'/performanceCheck',query:{'store_id':store.id}}" title="业绩查看" is-link >
        <van-icon slot="icon" class=" iconfont icon-Performance col_59AAFF"/>
      </van-cell>
      <van-cell :to="{path:'/store_tech',query:{'store_id':store.id}}" title="技师管理" is-link>
        <van-icon slot="icon" class=" iconfont icon-guanli col_EA6953"/>
      </van-cell>
      <van-cell :to="{path:'/store_selectItem',query:{'store_id':store.id}}"  title="选择项目" is-link>
        <van-icon slot="icon" class=" iconfont icon-fuwuxiangmu col_45B9BC fs_22"/>
      </van-cell>
      <template v-if="work_status==3">
        <van-cell title="营业状态" is-link  >
          <van-icon slot="icon" class=" iconfont icon-biaoqian1 col_45B9BC fs_22"/>
          <div class="van-cell__value">
            <span class="technician_status technicial_status_bg">已下架</span>
          </div>
        </van-cell>
      </template>
      <template v-else>
        <van-cell title="营业状态" is-link  @click="showPopup">
          <van-icon slot="icon" class=" iconfont icon-biaoqian1 col_45B9BC fs_22"/>
          <div class="van-cell__value">
            <span :class="['technician_status',work_status==2?'technicial_status_bg':'']">{{work_status==2?'休息':'营业'}}</span>
          </div>
        </van-cell>
      </template>
      
      <van-cell  :to="{path:'/storeInfo',query:{'store_id':store.id}}" title="门店信息" is-link>
        <van-icon slot="icon" class=" iconfont icon-wodeziliao col_59AAFF"/>
      </van-cell>
    </div>
    <!--营业状态-弹窗-->
    <van-popup v-model="work_show" :closeable="true" :round="true">
      <p class="wks_label">请选择当前状态</p>
      <div class="statePopup__itemBox">
        <div class="wks_icon" @click="update_workstatus(1)">
          <span :class="['iconfont','icon-gongzuoxinxi1',work_status==1?'work_status':'']"></span>
          <p>营业</p>
        </div>
        <div class="wks_icon" @click="update_workstatus(2)">
          <span :class="['iconfont','icon-xiuxi1',work_status==2?'work_status':'']"></span>
          <p>休息</p>
        </div>
      </div>
      <div class="btn_box">
        <button @click="closePopup" class="check_btn">确认</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "storeCenter",
    data(){
      return{
        //订单状态-图标
        icon:{
          order_icon1:'../../../static/img/order_icon1.png',
          order_icon2:'../../../static/img/center_daifuwu.png',
          order_icon3:'../../../static/img/center_yiwancheng.png',
          order_icon4:'../../../static/img/center_quxiaodingdan.png',
        },        
        //门店信息
        store: [],
        work_status: 1,
        work_show: false,
        order_status:99,
        totaldaijiedan:0,
        totaldaifuwu:0,
        totalhexiao:0,
        totalyichuli:0,
      }
    },
    created(){
        this.get_store();
    },
    methods:{
      get_store(){
        this.axios({
          url: this.api.store.store_center,
          data: {}
        }).then(res => {
          if (res.error === 0) {
            this.store = res.store_data;
            this.work_status = res.store_data.status;            
            this.totaldaijiedan  =res.store_order_status1;
            this.totaldaifuwu  =res.store_order_status2;
            this.totalhexiao  =res.store_order_status3;
            this.totalyichuli  =res.store_order_status_none;

          }
        });
      },
      order_jump(status = 0){
         this.$router.push({path:"/store_order",query:{'status':status}});
      },
      showPopup() {
        this.work_show =true;
      },
      closePopup() {
        var that  =this;
        this.work_show = false;
          this.axios({
          url: this.api.store.store_status,
          data: {status:this.work_status}
        }).then(res => {
          if (res.error == 0) {
            that.get_store();
          }
        });
      },
      update_workstatus(status){
        this.work_status = status;
        
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  .storeCenter__info{
    padding: 0 .5rem .25rem;
    z-index: 99;
    /* margin-top: -1.75rem; */
    position: relative;
    left: 0;
    right: 0;
  }
  .storeCenter__info .storeList{
    border-radius: .15rem;
    overflow: hidden;
  }
  .storeInfo__details>p{
    padding: 1px 0;
  }
  .storeOrder__menu{
    padding: .65rem .75rem;
    background: #fff;
  }
  .van-tabbar-item__icon img{
    width:1.3rem;
    height: 1.3rem;
    margin-bottom: .2rem;
  }
  .van-tabbar-item{
    font-size: .65rem;
  }
  .van-cell .iconfont{
    margin-right: .5rem;
    font-size: 1rem;
    width: 1rem;
    line-height: 1.3rem;
    height: 1.2rem;
    text-align: center;
  }


  /*弹窗*/
  .technician_status {
    color: white;
    background-color: #45b9bc;
    border-radius: 5px;
    padding: 0 0.5rem;
  }
  .technicial_status_bg{
    background-color: #D2D2D2;
  }
  .van-popup {
    width: 75%;
  }
  .wks_label {
    font-size: 0.75rem;
    padding: 1rem;
    color: #666;
  }
  .statePopup__itemBox{
    padding: 1rem 1.2rem;
    overflow: hidden;
  }
  .wks_icon{
    width:50%;
    float:left;
    text-align:center;
    font-size:.75rem;
    color:#5C5A5A;
  }
  .wks_icon span{
    font-size:3rem;
    color:#D2D2D2;
  }
  .btn_box{
    text-align:center;
  }
  .check_btn{
    background-color:#45B9BC;
    color:white;
    padding:.4rem 3.5rem;
    font-size:.9rem;
    border-radius:.25rem;
    margin:1.25rem 0 1.5rem;
  }
  .work_status{
    color:#45B9BC !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/storeCenter.vue